<template>
  <div class="tw:flex tw:flex-col tw:h-screen tw:max-h-screen">
    <ScrollPanel
      class="layout-main-container tw:grow"
      :dt="{
        bar: {
          background: '{primary.color}',
          opacity: 0.5,
          hoverOpacity: 0.7,
          size: '4px',
        },
      }"
    >
      <section class="tw:h-full tw:bg-white">
        <router-view v-slot="{ Component, route: routerRoute }">
          <transition :name="routerRoute.meta?.transition || 'fade'" mode="out-in" appear>
            <div v-if="show" :key="routerRoute.fullPath">
              <component :is="Component" :key="routerRoute.fullPath"></component>
            </div>
          </transition>
        </router-view>
      </section>
    </ScrollPanel>
    <Toast position="top-right" />
  </div>
</template>

<script setup>
import { ref } from 'vue';
const show = ref(true);
</script>

<style lang="scss" scoped>
.fade {
  &-enter-active,
  &-leave-active {
    transition: opacity 0.5s;
  }

  &-enter-from,
  &-leave-to {
    opacity: 0;
  }
}

.slide-fade {
  &-enter-active {
    transition: all 0.3s ease-out;
  }

  &-leave-active {
    transition: all 0.8s cubic-bezier(1, 0.5, 0.8, 1);
  }

  &-enter-from,
  &-leave-to {
    transform: translateX(20px);
    opacity: 0;
  }
}
</style>
